import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

import { ToolboxComponent } from '../toolbox.component';
import { ToolboxService } from '../toolbox.service';

@Component({
  selector: 'product-chooser-toolbox',
  templateUrl: './product-chooser-toolbox.component.html',
  styleUrls: [ '../toolbox.component.scss']
})
export class ProductChooserToolboxComponent extends ToolboxComponent
{
  @ViewChild('productChooser') public productChooser: any;

  constructor(
      private cdr: ChangeDetectorRef,
      mir: MatIconRegistry,
      sanitizer: DomSanitizer,
      @Inject(ToolboxService) toolboxService)
  {
    super(mir, sanitizer, toolboxService);
  }

  public openProductChooserDirectly(event: MouseEvent): void
  {
    this.productChooser.onClick(event);
    this.cdr.detectChanges();
    const overlayPane =
        <HTMLElement>document.querySelector('.cdk-overlay-pane');
    if (event.x + overlayPane.offsetWidth > window.innerWidth) {
      overlayPane.style.marginLeft =
          (window.innerWidth - overlayPane.offsetWidth) + 'px';
    }
    else {
      overlayPane.style.marginLeft = event.x + 'px';
    }
    if (event.y + overlayPane.offsetHeight > window.innerHeight) {
      overlayPane.style.marginTop =
          (window.innerHeight - overlayPane.offsetHeight) + 'px';
    }
    else {
      overlayPane.style.marginTop = event.y + 'px';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/toolboxes/product-chooser-toolbox/product-chooser-toolbox.component.ts